/**
 * Admin "act-as" impersonation API (SUPPORT-IMPERSONATION).
 *
 * `start` returns an act-as access token (held in memory like any other)
 * and sets the act-as refresh cookie server-side. `exit` pops one level:
 * `restored: "parent"` carries the parent session's token; `"superadmin"`
 * means the client restores its own session via `/auth/refresh`. The
 * act-as *refresh* is handled in `client.ts` (the 401 path routes to
 * `/impersonation/refresh` while impersonating).
 */
import { apiClient } from './client';

export interface StartImpersonationBody {
  target_user_id: string;
  /** Required for a top-level (tenant_admin) start; ignored when nested. */
  tenant_id?: string;
  read_only: boolean;
  reason: string;
}

export interface TokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface ImpersonationExitResponse {
  restored: 'parent' | 'superadmin';
  access_token: string | null;
  token_type: string;
  expires_in: number | null;
}

export async function startImpersonation(
  body: StartImpersonationBody,
): Promise<TokenResponse> {
  const { data } = await apiClient.post<TokenResponse>(
    '/api/v1/impersonation/start',
    body,
  );
  return data;
}

export async function exitImpersonation(): Promise<ImpersonationExitResponse> {
  const { data } = await apiClient.post<ImpersonationExitResponse>(
    '/api/v1/impersonation/exit',
  );
  return data;
}
